module.exports = __webpack_public_path__ + "static/media/Header 4.a92ff7c2.svg";